import { render, staticRenderFns } from "./Table.html?vue&type=template&id=aa054030&scoped=true&"
import script from "./Table.js?vue&type=script&lang=js&"
export * from "./Table.js?vue&type=script&lang=js&"
import style0 from "./Table.scss?vue&type=style&index=0&id=aa054030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa054030",
  null
  
)

export default component.exports